export default {
  "HitPaw Online Audio Extractor": "HitPaw ऑनलाइन ऑडियो एक्सट्रैक्टर",
  "Extract sound from videos with ease.": "आसानी से वीडियो में से साउंड निकालें।",
  "Select Audio Format": "ऑडियो फॉर्मेट चुनें",
  "Extract Audio": "ऑडियो निकालें",
  "Extracting Audio": "ऑडियो निकाला जा रहा है",
  "Extracted Successfully": "सफलतापूर्वक निकाला गया",
  "Extract New": "नया निकालें",
  "Extraction Failed": "निकालना विफल",
  "Format": "फॉर्मेट",
};
